// third-party
import { FormattedMessage } from "react-intl";

// assets
import ExpertsIcon from "../assets/icons/laurel-wreath-01.svg";

const icons = {
  experts: () => <img src={ExpertsIcon} alt="experts icon" />,
};

const experts = {
  id: "experts",
  title: <FormattedMessage id="experts" />,
  type: "group",
  url: "/experts",
  icon: icons.experts,
};

export default experts;
